import axios from 'axios'
import {
  setFormValues,
  setFilterValues,
  toggleFilterValues,
} from '../../modules/mutations.js'
import { castAttributesForCamelCase } from '../../modules/string_converter'

export const companiesUserCompany = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
    errors: null,
    message: null,
  },
  mutations: {
    readUserCompany(state) {
      state.data = null
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    updateUserCompany(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    readUserCompaniesSuccess(state, payload) {
      state.data = payload.data.map(v => {
        const value = castAttributesForCamelCase(v.attributes)
        value.id = Number(v.id)
        value.stores = v.relationships.stores.data
        return value
      })
      state.loading = false
    },
    readUserCompanySuccess(state, payload) {
      state.data = payload.data
      state.loading = false
      state.loadError = false
    },
    updateUserCompanySuccess(state, payload) {
      state.data = payload.data
      state.loading = false
      state.loadError = false
      state.message = 'メンバーの権限を変更しました'
    },
    apiFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors.response.data.errors[0].detail
    },
    setFormValues,
    setFilterValues,
    toggleFilterValues,
  },
  actions: {
    readUserCompanies({ commit, rootState }) {
      commit('readUserCompany')
      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/user_companies.json')
        .then(res => {
          commit('readUserCompaniesSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure', err)
          console.error(err)
        })
    },
    readUserCompany({ commit }, { company_uuid, user_company_id }) {
      commit('readUserCompany')
      return axios
        .get('/api/companies/' + company_uuid + '/user_companies/' + user_company_id + '.json')
        .then(res => {
          commit('readUserCompanySuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure', err)
          console.error(err)
        })
    },
    updateUserCompany({ commit }, { company_uuid, user_company_id, payload }) {
      commit('updateUserCompany')
      return axios
        .patch('/api/companies/' + company_uuid + '/user_companies/' + user_company_id + '.json', payload)
        .then(res => {
          commit('updateUserCompanySuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure', err)
          console.error(err)
        })
    },
    setFormValues({ commit }, values) {
      commit('setFormValues', values)
    }
  }
}
